<template>
	<div v-if="pageloaded">
		<div id="homePage" v-if="loaded && !isSearch">
			<section class="top_banner hp_slider_wrap">
				<div class="arrow_r ease home_arrow_r" style="display: none">
					<a href="javascript:void(0);" @click.prevent="prevBanner">
						<arrow-right />
					</a>
				</div>
				<div class="arrow_l ease home_arrow_l" style="display: none">
					<a href="javascript:void(0);" @click.prevent="nextBanner">
						<arrow-left />
					</a>
				</div>
				<div class="hp_slider absolute clearfix">
					<Slick
						ref="topBanners"
						:options="slickOptions"
						v-if="page.acf.banners && slickOptions.nextArrow && slickOptions.prevArrow"
					>
						<div class="hp_slider_item" v-for="(banner, index) in page.acf.banners" v-bind:key="index">
							<a-div
								:href="parseLink(banner.link)"
								:target="banner.link.target"
								class="absolute cover"
								v-lazy:background-image="banner.banner.desktop"
							>
								<span
									class="mobile_only absolute mobile_banner cover"
									v-lazy:background-image="banner.banner.mobile"
								>
									<span class="container"></span>
								</span>
							</a-div>
						</div>
					</Slick>
				</div>
				<div class="bn_corner"></div>
			</section>

			<div id="active-order-notice" v-if="hasOrderEdit">
				<router-link :to="{ name: 'history' }">
					<p id="active-order-notice-content">
						היי {{ this.$store.state.userLoggedInfo.firstname.substr(0, 10) }}, יש לך הזמנה פעילה. כדי לערוך
						אותה <u>לוחצים כאן</u>
						<span id="active-order-notice-svg-container">
							<PEN id="active-order-notice-icon" />
						</span>
					</p>
				</router-link>
			</div>

			<section class="hp_products">
				<div class="container">
					<div class="mobile_only">
						<div class="flex mobile-home-toolbar">
							<!-- btn open menu -->
							<div class="bt_green bt--big">
								<a class="flex" href="#menu"
									>קניה לפי מחלקות <img :src="assets_url + '/svg/arrows-sm.svg'"
								/></a>
							</div>

							<div class="view-switcher">
								<a
									href="#"
									:class="{ selected: productsView == 'grid' }"
									@click="setProductsView('grid')"
								>
									<GRID />
								</a>
								<a
									href="#"
									:class="{ selected: productsView == 'list' }"
									@click="setProductsView('list')"
								>
									<LIST />
								</a>
							</div>
						</div>
					</div>

					<h2 class="title center"><span>הכי כדאי היום</span></h2>
					<div class="category_inner_prods row flex flex--start products_wrap" :class="productsView">
						<!-- duplicate products only mobile/desktop -->
						<template v-for="(product, index) in products">
							<Product
								ref="productComponent"
								v-bind:product="product"
								v-bind:index="index"
								:key="product.id"
							></Product>
							<div
								class="product_wrap col-lg-4 col-md-6 col-sm-8 col-xs-12 hp-products-banner"
								:key="index"
								v-if="$mq === 'mobile' ? index == 3 : index == 3"
							>
								<div class="pr_publish home-rounded" v-if="page">
									<a-div :href="parseLink(page.acf.home_products_banner.link)" :new-window="false">
										<img
											:src="page.acf.home_products_banner.image.url"
											:alt="page.acf.home_products_banner.image.alt"
										/>
									</a-div>
								</div>
							</div>
							<template v-if="index == 11">
								<InlinePromotion
									:promo="page.acf.home_products_banner_bottom"
									:home_url="homeUrl"
									:assets="assets_url"
								/>
							</template>
						</template>
					</div>
				</div>
			</section>

			<section class="image-banner banner-after-products" v-if="page.acf.home_after_products_banner">
				<div class="container">
					<a-div
						:href="parseLink(page.acf.home_after_products_banner.link)"
						v-html="page.acf.home_after_products_banner[this.$mq == 'desktop' ? 'image' : 'image_mobile']"
					>
					</a-div>
				</div>
			</section>

			<section class="product-carousel-section">
				<ProductsCarousel :title="page.acf.product_slider.title" :products="sliderProducts" />
			</section>

			<section
				class="image-banner banner-after-recepies"
				v-if="this.$mq === 'mobile' && page.acf.home_after_recipe_banner"
			>
				<div class="container">
					<a-div
						:href="parseLink(page.acf.home_after_recipe_banner.link)"
						v-html="page.acf.home_after_recipe_banner[this.$mq === 'desktop' ? 'image' : 'image_mobile']"
					>
					</a-div>
				</div>
			</section>

			<Blogs />

			<section
				class="image-banner banner-after-recepies"
				v-if="this.$mq === 'desktop' && page.acf.home_after_recipe_banner"
			>
				<div class="container">
					<a-div
						:href="parseLink(page.acf.home_after_recipe_banner.link)"
						v-html="page.acf.home_after_recipe_banner[this.$mq === 'desktop' ? 'image' : 'image_mobile']"
					>
					</a-div>
				</div>
			</section>

			<section class="home-instagram no_mobile">
				<div class="container">
					<div class="title center" v-html="page.acf.instagram.title"></div>
					<div class="subtitle center" v-html="page.acf.instagram.subtitle"></div>

					<div class="instagram-feed">
						<a v-for="(item, index) in instagram_feed" :key="index" :href="item.permalink" target="_blank" class="item">
							<img
								:src="item.thumbnail_url ? item.thumbnail_url : item.media_url"
								:alt="item.caption"
								:title="item.caption"
							/>
              <div class="overlay"></div>
						</a>
					</div>

					<div class="bt_green ease">
						<a href="https://www.instagram.com/carmella.co.il/" target="_blank">
							<span><span>@carmella.co.il</span></span>
						</a>
					</div>
				</div>
			</section>

			<section class="pre-footer">
				<div class="row">
					<div class="pre-footer-item col-sm-4" v-for="(item, index) in page.acf.home_prefooter" :key="index">
						<h3 class="title">
							<span class="title-top" v-html="item.title_top"></span>
							<span class="title-bold" v-html="item.title_bold"></span>
						</h3>
						<div class="text" v-html="item.content"></div>
						<div class="bt_green ease">
							<a-div :href="parseLink(item.button_link)">{{ item.button_text }}</a-div>
						</div>
					</div>
				</div>
			</section>
		</div>

		<div id="Search" v-if="loaded && isSearch">
			<search />
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import Product from "../components/Product/Product";
	import arrowLeft from "../assets/img/arrow_l.svg";
	import arrowRight from "../assets/img/arrow_r.svg";
	import arrowLong from "../assets/img/arrow-long.svg";
	import CHEF from "../assets/img/chef.svg";
	import { mapGetters, mapMutations, mapState } from "vuex";
	import Slick from "vue-slick";
	import Blogs from "../components/Home/Blogs.vue";
	import Search from "../views/Search";
	import PEN from "../assets/img/pen.svg";
	import GRID from "../assets/img/grid-2-solid.svg";
	import LIST from "../assets/img/list-solid.svg";
	import InlinePromotion from "@/components/InlinePromotion";
	import ProductsCarousel from "@/components/ProductsCarousel";
	import "vue3-instagram-feed/dist/style.css";

	export default {
		name: "home",
		data() {
			return {
				homeUrl: wpData.home_url,
				assets_url: wpData.assets_url,
				instagram_feed: wpData.instagram_feed,
				//banners: JSON.parse(wpData.home_baners),
				//products_ids: JSON.parse(wpData.home_products),
				//pageData: "",
				slickOptions: {
					slidesToShow: 1,
					rtl: true,
					dots: true,
					nextArrow: false,
					prevArrow: false,
					infinite: true,
					centerMode: false,
					slidesToScroll: 1,
					autoplay: false,
					fade: true,
					autoplaySpeed: 3000,
					// Any other options that can be got from plugin documentation
				},
				slickOptionsSpecial: {
					slidesToShow: 4,
					rtl: true,
					dots: false,
					nextArrow: false,
					prevArrow: false,
					infinite: false,
					centerMode: false,
					slidesToScroll: 2,
					autoplay: false,
					//fade:true,
					autoplaySpeed: 1000,
					responsive: [
						{
							breakpoint: 650,
							settings: {
								slidesToShow: 3,
							},
						},
					],
					// Any other options that can be got from plugin documentation
				},
				pageloaded: false,
			};
		},
		mounted() {
			this.pageloaded = true;
			if (!this.$route.query.s) {
				//this.$store.commit("setProducts", this.page.acf.products);
				if (this.$mq == "mobile") {
					this.$store.commit("setProducts", this.page.acf.products_mobile);
				} else {
					this.$store.commit("setProducts", this.page.acf.products);
				}
			}
			this.$nextTick(() => {
				let r_arrow = $(".home_arrow_r");
				let l_arrow = $(".home_arrow_l");
				this.slickOptions.nextArrow = l_arrow;
				this.slickOptions.prevArrow = r_arrow;
			});

			if (this.$route.query && this.$route.query["load-cart-preset"]) {
				this.$modal.show("load-cart-preset");
			}
		},
		watch: {
			isSearch(value) {
				if (!value) {
					this.$store.commit("setProducts", this.page.acf.products);
				}
			},
		},
		methods: {
			...mapMutations(["setProductsView"]),
			filteredCatList(items) {
				items = items.filter((category) => {
					return category.parent == 0;
				});
				return items;
			},
			resolveRouteByName(name) {
				let prop = this.$router.resolve({
					name: name,
				});
				return prop.resolved.fullPath;
			},
			nextBanner() {
				this.$refs.topBanners.next();
			},
			prevBanner() {
				this.$refs.topBanners.prev();
			},
			parseLink(link) {
				if (link) {
					if (typeof link == "object") {
						if (link.target) {
							return link.url;
						}
						return link.url.replace(this.homeUrl, "");
					} else {
						return link.replace(this.homeUrl, "");
					}
				}
				return "#";
			},
			getCategoryLinkById(id) {
				let cats = this.$store.state.categories;
				let find = cats.find((cat) => cat.id == id);
				if (typeof find != "undefined") {
					return this.homeUrl + find.link;
				}
				return "javascript:void(0)";
			},
			openMenu(id) {
				if ($(".menu_item[data-object-id=" + id + "]").find(".drop_col .drop_link").length == 1) {
					$(".menu_item[data-object-id=" + id + "]")
						.find(".drop_col .drop_link a")[0]
						.click();
					return;
				}

				$(".menu_bt").find("a").trigger("click");
				$(".menu_item[data-object-id=" + id + "]")
					.find(".drop_down")
					.trigger("click");
				setTimeout(() => {
					$(".mm-panel").animate(
						{
							scrollTop: $(".mm-panel").scrollTop() + $(".menu_item.active").position().top,
						},
						500
					);
				}, 500);
			}
		},
		computed: {
			// ...mapGetters(["getProductById"]),
			...mapState(["userLogged", "hasOrderEdit", "productsView"]),
			page: function () {
				if (typeof wpData.pageData != "object") {
					return JSON.parse(wpData.pageData);
				}
				return wpData.pageData;
			},
      sliderProducts: function(){
        const filteredProducts = Object.values(this.page.acf.product_slider.products).filter(
            (product) => Object.keys(product).length > 0
        );

        return filteredProducts;
      },
			products_ids: function () {
				return this.page.acf.products;
			},
			products: function () {
				if (this.pageloaded) {
					return this.$store.state.products;
					//return this.page.acf.products;
					// var products = [];
					// this.products_ids.map(p => {
					//   if (typeof this.getProductById(p) != "undefined") {
					//     products.push(this.getProductById(p));
					//   }
					// });
					// return products;
				}
			},

			loaded: function () {
				return true;
				if (this.$store.state.products.length > 0) {
				}
				return false;
			},
			isSearch: function () {
				if (this.$route.query.s) {
					return true;
				}
				return false;
			},
		},
		components: {
			InlinePromotion,
			arrowRight,
			arrowLeft,
			arrowLong,
			CHEF,
			Product,
			Slick,
			Blogs,
			Search,
			PEN,
			GRID,
			LIST,
			ProductsCarousel,
		},
	};
</script>

<style lang="scss" scoped>
	div#homePage {
		.title {
			color: #355731;
		}

		section.hp_products {
			.hp-products-banner {
        @media (max-width: 480px) {
          padding: 0 6px;
        }
				.pr_publish {
					margin: 0 0 20px;

					img {
						height: 337px;
						width: 100%;
						object-fit: cover;
						object-position: right;

						@media (max-width: 480px) {
							height: auto;
							width: 100%;
						}
					}
				}
			}
		}

		section.image-banner {
			margin-bottom: 3em;
			@media (max-width: 480px) {
				margin-bottom: 2em;
			}


			::v-deep img {
				width: 100%;
				height: auto;
				border-radius: 0 0 22px 22px;
				overflow: hidden;

				@media (max-width: 480px) {
					border-radius: 0;
				}
			}
		}

		section.home-instagram {
			margin-bottom: 4em;

			.title {
				margin: 0;
				line-height: 1;
			}

			.subtitle {
				font-weight: 400;
				font-size: 16px;
				line-height: 22px;
				color: #355731;
				margin-bottom: 2em;
			}

			.bt_green {
				a {
					direction: ltr;
					background: linear-gradient(90deg, #ff7f4f 0%, #ca35ac 100%);
					padding: 1px;
					height: auto;
					line-height: 40px;

					& > span {
						display: block;
						background: #efede9;
						border-radius: 50px;

						span {
							display: block;
							border: 0;
							background-image: linear-gradient(90deg, #ff7f4f 0%, #ca35ac 100%);
							color: transparent;
							background-clip: text;
						}
					}
				}
			}

			.instagram-feed {
				display: flex;
        gap: 20px;

				.item {
					flex: 0 1 25%;
					max-width: 25%;
          border-radius: 22px;
          overflow: hidden;
          position: relative;

					img {
						width: 100%;
						object-fit: cover;
						aspect-ratio: 1 / 1.2;
					}

          &:hover {
            .overlay {
              opacity: 0;
            }
          }

          .overlay {
            position: absolute;
            right: 0;
            left: 0;
            bottom: 0;
            top: 0;
            background: #00000024;
            transition: 300ms ease all;

            &:after {
              content: '';
              position: absolute;
              right: 0;
              left: 0;
              bottom: 0;
              top: 0;
              margin: 10px;
              border: 1px solid #fff;
              border-radius: 22px;
            }
          }
				}
			}
		}

		section.pre-footer {
			overflow: hidden;

			.row {
				margin: 0;
				display: flex;

				@media (max-width: 480px) {
					flex-direction: column;
				}
			}

			.pre-footer-item {
				display: flex;
				flex-direction: column;

				.title {
					line-height: 0.8;

					.title-top {
						display: block;
					}

					.title-bold {
						display: block;
						font-weight: bold;
					}
				}

				.text {
					::v-deep p {
						margin-bottom: 1em;
					}
				}

				.bt_green {
					margin-top: auto;

					a {
						margin: 4em 0 0;
						background: none;
						border: 1px solid #1e824c;
						color: #1e824c;
						width: auto;
						height: auto;
						line-height: normal;
						justify-self: start;
						padding: 10px 3em;

						&:hover {
							background: #1e824c;
							color: #fff;
						}

						@media (max-width: 480px) {
							margin: 0.5em 0 1em;
							padding: 10px 25px;
              display: inline-block;
						}
					}
				}

				&:nth-child(1) {
					background: #f4ffea url("../assets/img/prefooter1.png") no-repeat right bottom/auto;
					padding: 3em 12em 3em 4em;

					.title {
						color: #1e824c;
					}

					@media (max-width: 480px) {
						padding: 1em 1.5em;
						background-image: none !important;

						&:after {
							content: "";
							position: absolute;
							bottom: -42%;
							left: -13px;
							background: url("../assets/img/image 39.png") no-repeat center/contain;
							width: 165px;
							height: 265px;
							z-index: 1;
						}
					}
				}

				&:nth-child(2) {
					background: #c9e5c2;
					padding: 3em 9em 3em 6em;

					&:after {
						content: "";
						position: absolute;
						bottom: 0;
						right: -95px;
						background: url("../assets/img/prefooter2.png") no-repeat center/auto;
						width: 260px;
						height: 154px;
					}

					.title {
						color: #e14b40;
					}

					@media (max-width: 480px) {
						padding: 1em 1.5em;

						&:after {
							right: auto;
							left: -11%;
							z-index: 1;
							width: 205px;
							height: 122px;
							bottom: auto;
							top: 100%;
							background-size: contain;
						}

						h3.title {
							padding-left: 2em;
						}
					}
				}

				&:nth-child(3) {
					background: #dcffd3 url("../assets/img/prefooter3.png") no-repeat left bottom/auto;
					padding: 3em 5em 3em 10em;

					.title {
						color: #355731;
					}

					@media (max-width: 480px) {
						padding: 1em 1.5em;
						background-image: none;

						.title {
							padding-left: 3em;
						}
					}
				}

				@media (min-width: 1024px) and (max-width: 1440px) {
					.title {
						font-size: 42px;
					}
					.bt_green {
						a {
							margin-top: 45px;
						}
					}
					&:nth-child(1) {
						background-size: 70px;
						padding: 3em 6em 3em 2em;
					}
					&:nth-child(2) {
						padding: 3em 5em 3em 5em;

						&:after {
							background-size: contain;
							width: 190px;
							height: 113px;
						}
					}
					&:nth-child(3) {
						padding: 3em 3em 3em 6em;
						background-size: 160px;
					}
				}
			}
		}

		.mobile-home-toolbar {
			gap: 20px;

			.bt_green.bt--big {
				flex: 1;

				a {
					margin: 0;
				}
			}

			.view-switcher {
				background: #fff;
				//display: flex;
				display: none;
				gap: 10px;
				align-items: center;
				justify-content: center;
				padding: 0 15px;
				border-radius: 20px;

				a {
					display: flex;

					svg {
						height: 27px;
						fill: #c4c4c4;
					}

					&.selected svg {
						fill: #757575;
					}
				}
			}
		}
	}
</style>

<style>
	.white_tag {
		background-color: #fff;
		color: #213519;
		height: 30px;
		font-size: 32px;
		line-height: 30px;
	}

	.bt_orange svg {
		fill: #fff;
	}
	.bt_orange:hover {
		border-color: #213519;
	}
	.bt_orange {
		background-color: #ea4726;
		color: #fff;
		border-color: #ea4726;
	}
</style>

<style scoped>
	.pr_publish:before {
		display: none;
	}
	.pr_publish a {
		padding: 0;
	}
	.pr_publish.home-rounded {
		border-radius: 0 0 20px 20px;
	}
	.mobile_only .pr_publish {
		margin: 0;
		border-radius: 20px 0px 0 0px;
	}
	.mobile_only .pr_publish img {
		width: 100%;
	}
</style>

<style lang="sass" scoped>
	#active-order-notice
	  position: relative
	  text-align: center
	  background-color: #ea4726
	  transform: translateY(-20px)

	  a
	    display: block
	    padding: 0.5rem 1rem

	#active-order-notice-content
	  text-align: right
	  padding-left: 3.25rem
	  color: #ffffff

	#active-order-notice-svg-container
	  position: absolute
	  top: 50%
	  left: 1rem
	  transform: translateY(-50%)
	  background-color: #f8bd3a
	  width: 1.85rem
	  height: 1.85rem
	  border-radius: 0.25rem

	  svg
	    position: absolute
	    top: 50%
	    left: 50%
	    transform: translate(-50%, -50%)
	    width: 60%

	    path
	      fill: #3c5638

	/* Desktop and tablet */
	@media screen and (min-width: 700px)
	  #active-order-notice
	    line-height: 2.5rem
	  #active-order-notice-content
	    position: relative
	    width: 600px
	    margin: 0 auto
	    text-align: center
	  #active-order-notice-svg-container
	    position: relative
	    top: auto
	    left: auto
	    transform: translateY(0.55rem)
	    display: inline-block
	    margin-right: 1rem

	@media screen and (min-width: 800px)
	  #active-order-notice
	    transform: translateY(-79px)
</style>
